<template>
    <div class='header space_b'>
        <img class="left cur" @click="gohome" src="../assets/logo.png" />
        <div class="right flex">
            <div 
                class="cur" 
                :class="isindex == i?'Selopt':''"
                v-for="(m,i) in list" 
                :key="i" 
                @click="choice(m,i)">
                {{m.text}}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isindex:0,
            list:[ 
                {
                    text:'网站首页',
                    name:'home'
                },
                {
                    text:'关于我们',
                    name:'about'
                },
                {
                    text:'网站建设',
                    name:'build',
                    type:true
                },
                {
                    text:'手机应用',
                    name:'app'
                },
                {
                    text:'微信营销',
                    name:'Wx'
                },
                {
                    text:'硬件开发',
                    name:'hardware',
                    type:true
                },
                // {
                //     text:'联系我们',
                //     name:'Us'
                // },
            ]
        };
    },
    methods: {
        choice(m,i){
            if (!m.type) {
                this.isindex = i
                this.$router.push({name:m.name})
            }
        },
        gohome(){
            if (this.$route.name != 'home') {
                this.$router.push({name:'home'})
            }
        },
    },
}
</script>
<style lang="less" scoped>
    .header{
        height: 80px;
        background: #3081ed;
        box-sizing: border-box;
        padding: 20px 58px;
        color: #fff;
        .left{
            width: 141px;
	        height: 42px;
        }
        .right{
            font-size: 18px;
            .cur{
                margin-left: 50px;
                padding-top: 11px;
                &.Selopt{
                    position: relative;
                    &::after{
                        position: absolute;
                        content: '';
                        bottom: -2px;
                        left: 7px;
                        right: 7px;
                        height: 2px;
                        background: #fff;
                    }
                }
            }
        }
    }
    
</style>